import { User, newUser } from "../types/User";
import { getCurrentUser } from "../../features/api/userSlice";

import React, { useContext, createContext, useEffect } from "react";

interface AuthContextProps {
    user: User;
    setUser: React.Dispatch<React.SetStateAction<User>>;
}

const init: AuthContextProps = {
    user: newUser(),
    setUser: () => {},
};

const AuthContext = createContext<AuthContextProps>(init);

interface AuthProviderProps {
    children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [currentUser, setCurrentUser] = React.useState<User>(newUser());

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const user = await getCurrentUser();
                setCurrentUser(user);
                console.info("User signed in");
            } catch (err) {
                console.info("No user signed in");
            }
        };

        fetchUser();
    }, []);

    return (
        <AuthContext.Provider value={{ user: currentUser, setUser: setCurrentUser }}>{children}</AuthContext.Provider>
    );
};

// custom hook
export const useAuth = () => useContext(AuthContext);
